/* @jsx h */
import { computed, defineComponent, h, onMounted, ref } from "vue";
import type { Category, ProductCategoryReward } from "@lemmonhq/types";
import { SelectableListComboBox } from "@app/vue/components/index";
import type { SelectableItem } from "@app/vue/components/index";
import { api } from "@app/data/index";

type Props = {
  value: ProductCategoryReward;
  onChange: (reward: ProductCategoryReward) => void;
};

export const ProductCategoryRewardEditor = defineComponent<Props>({
  name: "ProductCategoryRewardEditor",
  props: ["value", "onChange"],
  setup(props) {
    const categories = ref<Category[]>([]);
    const loading = ref(false);
    onMounted(async () => {
      loading.value = true;
      try {
        categories.value = (await api.getServices()).flatMap(
          (service) => service.categories ?? [],
        ) as Category[];
      } finally {
        loading.value = false;
      }
    });
    const items = computed<SelectableItem[]>(() =>
      categories.value.map(({ id, name }) => ({ id, name })),
    );
    return () => (
      <div class="card border border-success/20 bg-success/5">
        <div class="card-body gap-4 p-4">
          <h4 class="card-title text-lg">Product category reward</h4>
          <SelectableListComboBox
            items={items.value}
            selectedIds={props.value.categories.map((category) => category.id)}
            onSelectionChange={(ids: number[]) =>
              props.onChange({
                ...props.value,
                categories: ids.map((id) => ({
                  id,
                  name:
                    categories.value.find((category) => category.id === id)
                      ?.name ?? "",
                })),
              })
            }
            loading={loading.value}
            placeholder="Search categories..."
            emptyMessage="No categories available"
            selectionLabel="category(ies) selected"
          />
          <label class="form-control max-w-xs">
            <span class="label-text font-medium">Free quantity</span>
            <input
              class="input input-bordered"
              type="number"
              min="1"
              value={props.value.quantity}
              onInput={(event) =>
                props.onChange({
                  ...props.value,
                  quantity:
                    parseInt((event.target as HTMLInputElement).value) || 1,
                })
              }
            />
          </label>
        </div>
      </div>
    );
  },
});
